/* 🤖 this file was generated by svg-to-ts*/
export const IconChevronright = {
    name: 'chevronright',
    data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.616 2.99a1.25 1.25 0 011.77 0l8.31 8.31c.39.39.39 1.02 0 1.41l-8.31 8.31c-.49.49-1.28.49-1.77 0a1.25 1.25 0 010-1.77l7.24-7.25-7.25-7.25c-.48-.48-.48-1.28.01-1.76z"/></svg>'
};
